import { useWrapAsync } from "@paroicms/front-app-log";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthUser, initialFetchAuthUser } from "../../../api-requests/users";
import { ClientError } from "../../../api/shared/http-client";
import { LOGIN_URL, appLog } from "../../../context";
import { useAppStore } from "../../../store/app.store";
import Spinner from "../../components/utils/Spinner/Spinner";
import {
  forgetSession,
  keepSession,
  verifyUserSession,
} from "../../shared/global-tools/session-storage";
import { showToast } from "../../shared/global-tools/toast-system";
import { getUrlParameter, replaceUrlParameters } from "../../shared/global-tools/url-parameters";
import AuthenticatedApp from "./AuthenticatedApp";

export default function AuthenticatedAppLoader() {
  const wrapAsync = useWrapAsync();
  const [ready, setReady] = useState(false);
  const [sessionLoading, setSessionLoading] = useState(true);
  const setAuthUser = useAppStore((state) => state.setAuthUser);
  const setAuthenticated = useAppStore((state) => state.setIsAuthenticated);
  const authenticated = useAppStore((state) => state.isAuthenticated);
  const navigate = useNavigate();

  useEffect(
    wrapAsync(async () => {
      try {
        setSessionLoading(true);
        const token = getUrlParameter("token");

        if (token) {
          forgetSession();
          try {
            const authUser = await initialFetchAuthUser(token);
            keepSession({ id: authUser.id, token });
            replaceUrlParameters();
            setAuthenticated(true);
            setAuthUser(authUser);
            setReady(true);
            setSessionLoading(false);
            return;
          } catch (error) {
            if (error instanceof ClientError) {
              showToast(error.message, { severity: "error" });
            } else {
              showToast("Une erreur est survenue", { severity: "error" });
            }
            setSessionLoading(false);
            navigate("/");
            return;
          }
        }

        const session = await verifyUserSession();
        if (session) {
          setAuthenticated(true);
          const authUser = await fetchAuthUser();
          setAuthUser(authUser);
          setReady(true);
        } else {
          window.location.href = LOGIN_URL;
          return;
        }
      } catch (error) {
        appLog.error(error);
        window.location.href = LOGIN_URL;
        return;
      } finally {
        setSessionLoading(false);
      }
    }),
    [],
  );

  // Show spinner while checking authentication or loading user data
  if (sessionLoading || !ready) return <Spinner />;
  if (authenticated && ready) {
    return <AuthenticatedApp />;
  }
  // Fallback spinner (should not normally reach here due to redirects)
  return <Spinner />;
}
